var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.valueLocal.label,"type":"date"},model:{value:(_vm.valueLocal.value),callback:function ($$v) {_vm.$set(_vm.valueLocal, "value", $$v)},expression:"valueLocal.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }